import { render, staticRenderFns } from "./PriceChangeNotice.vue?vue&type=template&id=28438651"
import script from "./PriceChangeNotice.vue?vue&type=script&lang=js"
export * from "./PriceChangeNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports